import dayjs, { Dayjs } from "dayjs"

export class AssetReadinessProblem {
    id?: number
    assetId: number = 0
    subject: string = ""
    description: string = ""
    started: Dayjs = dayjs()
    resolutionExpected: Dayjs = dayjs()
    resolutionCertified?: Dayjs

    parseObject(input: any) {
        this.id = input.id
        this.assetId = input.assetId
        this.subject = input.subject
        this.description = input.description
        this.started = dayjs(input.started)
        this.resolutionExpected = dayjs(input.resolutionExpected)
        this.resolutionCertified = input.resolutionCertified === undefined ? undefined : dayjs(input.resolutionCertified)
    }

    objectify(): object {
        return {
            id: this.id,
            assetId: this.assetId,
            subject: this.subject,
            description: this.description,
            started: this.started.format(),
            resolutionExpected: this.resolutionExpected.format(),
            resolutionCertified: this.resolutionCertified?.format()
        }
    }
}